import ApiService from '@/utils/ApiService'
import getIdFromLink from '@/utils/getIdFromLink'
import Swal from 'sweetalert2'
// import moment from 'moment'

export default {
  namespaced: true,
  state: {
    isAgreementAcceptModalVisible: false,
    agreementId: null,
    isAgreementLoading: false,
    agreement: {},
    accepted: false,
    signBySMS: null,
    wasSMSSend: false,
    SMSCode: '',
    SMSCount: '',
    error: ''
  },
  getters: {
    getAccepted: (state) => state.accepted,
    getIsAgreementAcceptModalVisible: (state) => state.isAgreementAcceptModalVisible,
    getIsLoadingAgreement: (state) => state.isAgreementLoading,
    getAgreement: (state) => state.agreement,
    getAgreementConsents: (state) => state.agreement.agreementsConsents,
    getSignBySMS: (state) => state.signBySMS,
    getWasSMSSend: (state) => state.wasSMSSend,
    getSMSCode: (state) => state.SMSCode,
    getSMSCount: (state) => state.SMSCount
  },
  mutations: {
    setError (state, payload) {
      state.error = payload
    },
    setSMSCode (state, payload) {
      state.SMSCode = payload
    },
    setSMSCount (state, payload) {
      state.SMSCount = payload
    },
    setWasSMSSend (state) {
      state.wasSMSSend = true
    },
    setSignBySMS (state, payload) {
      state.signBySMS = payload
    },
    setAccepted (state) {
      state.accepted = true
    },
    acceptSingleConsent (state, payload) {
      state.agreement.agreementsConsents[payload].agree = 2
    },
    discardSingleConsent (state, payload) {
      state.agreement.agreementsConsents[payload].agree = 1
    },
    setAgreementId (state, payload) {
      state.agreementId = payload
    },
    toggleAgreementAcceptModal (state) {
      state.isAgreementAcceptModalVisible = !state.isAgreementAcceptModalVisible
    },
    toggleLoadingAgreement (state) {
      state.isAgreementLoading = !state.isAgreementLoading
    },
    reset (state) {
      state.isAgreementAcceptModalVisible = false
      state.isAgreementLoading = false
      state.agreement = {}
      state.accepted = false
      state.agreementId = null
    },
    setAgreement (state, payload) {
      state.agreement = payload
    }
  },
  actions: {
    async fetchAgreement ({ commit, dispatch, state }) {
      commit('toggleLoadingAgreement')
      const response = await new ApiService(`e_x_a_b_agreements/${getIdFromLink(state.agreementId)}`).getResults()
      commit('toggleLoadingAgreement')
      commit('setAgreement', await response)
    },
    async acceptOffer ({ commit, state }) {
      let data = {}
      data['@id'] = state.agreementId
      if (state.agreement.agreementsConsents && state.agreement.agreementsConsents.length > 0) {
        data.agreementsConsents = state.agreement.agreementsConsents.map(consent => {
          return { '@id': consent['@id'], consent: consent.consent['@id'], agree: consent.agree, agreement: state.agreementId }
        })
      }
      const response = await new ApiService(`e_x_a_b_agreements/${getIdFromLink(state.agreementId)}/sign`).put(data)
      if (response.status === 200) {
        commit('setAccepted')
      }
    },
    async fetchSignBySMSFlag ({ commit }, id) {
      const response = await new ApiService(`e_x_a_b_agreements/${getIdFromLink(id)}/allowsigningagreementbysms`)
        .getResults()
      commit('setSignBySMS', await response)
    },
    async requestSignBySMS ({ commit, state }) {
      let data = {}
      data['@id'] = state.agreementId
      if (state.agreement.agreementsConsents && state.agreement.agreementsConsents.length > 0) {
        data.agreementsConsents = state.agreement.agreementsConsents.map(consent => {
          return { '@id': consent['@id'], consent: consent.consent['@id'], agree: consent.agree }
        })
      }
      const response = await new ApiService(`e_x_a_b_agreements/${getIdFromLink(state.agreementId)}/signagreementbysmsrequest`).post(data)
      if (response.status < 300) {
        commit('setWasSMSSend')
      }
      commit('setSMSCount', (await response.json())[1])
      // commit('setWasSMSSend')
      // commit('setSMSCount', 1)
    },
    async sign ({ commit, state }) {
      let data = {
        confirmationPin: state.SMSCode
      }
      const response = await new ApiService(`e_x_a_b_agreements/${getIdFromLink(state.agreementId)}/signagreementbysms`).post(data)
      if (response.status === 200) {
        commit('setAccepted')
      } else {
        let error = await response.json()
        Swal({
          type: 'warning',
          title: error[0],
          timer: 3500
        })
      }
    }
  }
}
